import React from 'react'
import { Svg } from './Svg'

export function Ghost(props): React.JSX.Element {
    return (
        <Svg fill="currentColor" {...props} viewBox="0 0 256 256">
            <circle cx="100" cy="116" r="12"/>
            <circle cx="156" cy="116" r="12"/>
            <path d="M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
        </Svg>
    )
}
